var _rect, _rect2, _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowerHex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 82,
    viewBox: "0 0 65 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5874,
    y: 75.0518,
    width: 18.4718,
    height: 6.14445,
    rx: 3.07223,
    fill: "#EB9413"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.3394,
    y: 75.0518,
    width: 18.4718,
    height: 6.14445,
    rx: 3.07223,
    fill: "#EB9413"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9778 47.3863C1.22631 44.2956 1.22631 40.5122 2.9778 37.4214L13.2258 19.3375C15.0201 16.1711 18.3785 14.2141 22.018 14.2141L42.1899 14.2141C45.8294 14.2141 49.1878 16.1711 50.9822 19.3375L61.2301 37.4214C62.9816 40.5122 62.9816 44.2956 61.2301 47.3863L50.9822 65.4703C49.1878 68.6366 45.8294 70.5936 42.19 70.5936H22.018C18.3785 70.5936 15.0201 68.6366 13.2258 65.4703L2.9778 47.3863Z",
    fill: "#EB9413"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1093 49.6888C39.2161 49.6888 44.9773 43.8118 44.9773 36.5622C44.9773 29.3125 39.2161 23.4355 32.1093 23.4355C25.0024 23.4355 19.2412 29.3125 19.2412 36.5622C19.2412 43.8118 25.0024 49.6888 32.1093 49.6888Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2466 42.3262C32.811 42.3262 35.7006 39.4152 35.7006 35.8242C35.7006 32.2333 32.811 29.3223 29.2466 29.3223C25.6821 29.3223 22.7925 32.2333 22.7925 35.8242C22.7925 39.4152 25.6821 42.3262 29.2466 42.3262Z",
    fill: "#570029"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.8451,
    cy: 7.58903,
    rx: 7.1019,
    ry: 7.2443,
    fill: "#3C1717"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.8451,
    cy: 22.0778,
    rx: 7.1019,
    ry: 7.2443,
    fill: "#3C1717"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.9696,
    cy: 14.8576,
    rx: 7.1019,
    ry: 7.2443,
    fill: "#3C1717"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.7664,
    cy: 14.8576,
    rx: 7.1019,
    ry: 7.2443,
    fill: "#3C1717"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.8421,
    cy: 14.8597,
    rx: 4.48127,
    ry: 4.57113,
    fill: "#FFEEED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerHex);
export default __webpack_public_path__ + "static/media/flower-hex.500f02c60832fabe9b5b3a99a9ad1ba3.svg";
export { ForwardRef as ReactComponent };